module.exports = __webpack_public_path__ + "img/boy-waking-sm.8698934f.png";